import { action } from 'satcheljs';
import { AttachmentSuggestions } from 'owa-mail-store';

export default action(
    'storeAttachmentSuggestionsOnItemAction',
    function storeAttachmentSuggestionsOnItemAction(
        referenceItemId: string,
        attachmentSuggestions: AttachmentSuggestions
    ) {
        return {
            referenceItemId: referenceItemId,
            attachmentSuggestions: attachmentSuggestions,
        };
    }
);
